import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";

import Header from "common/js/header/header";
import Loader from "common/components/Loader";
import ContentSlider from "./contentSlider";
import ContentTbl from "./contentTbl";

import { getContentListSvc } from "./contentSvc";



function PanelContentCtrl() {

  const [loader, setLoader] = useState("none");
  const [opacity, setOpacity] = useState(1);
  const [contentId, setContentId] = useState(0);
  const [lstContent, setLstContent] = useState([]);
  const [contentBasePath, setContentBasePath] = useState("");
  const [lstContentId, setLstContentId] = useState([]);
  const [flgContentSliderVisible, setFlgContentSliderVisible] = useState(false);
  const [contentObj, setContentObj] = useState({});
  const [key, setKey] = useState(0);


  useEffect(() => {
    // console.log("PanelContentCtrl called ");
    getContentList();
  }, [key]);


  const getContentList = () => {
    // console.log("getContentList called");
    setLoader("block");
    setOpacity(0.5);
    getContentListSvc(contentListResponse);
  }


  const contentListResponse = (data) => {
    // console.log("contentListResponse called, data", data);
    if (data.status === "Success") {
      // console.log("inside contentListResponse, data.lstContent", data.lstContent);
      setLstContent(data.lstContent);
      setContentBasePath(data.contentBasePath);
    } else if (data.status === "Failure") {
      handleServiceError(data.message);
    } else {
      toast.error("Service failed " + data.error);
    }
    setLoader("none");
    setOpacity(1);
  }

  const handleServiceError = (svcMsg) => {
    if (svcMsg === "You are not Logged In") {
      toast.error("You are not logged in. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else if (svcMsg === "Server Timed Out, Login Again") {
      toast.error("Server timed out. Redirecting to login page...");
      setTimeout(() => {
        window.location.href = "/";
      }, 2000);
    } else {
      toast.error(svcMsg);
    }
  };
  const mediaTypes = new Map([
    [10, "image"],
    [20, "video"],
    [30, "audio"]
  ]);
  const orientations = new Map([
    [10, "landscape"],
    [20, "portrait"],
    [30, "square"]
  ]);

  const addContent = async () => {
    // console.log("addContent called");
    await setContentObj({});
    await setContentId(0);
    openEditSlider();
  }

  const editContent = async (pContent) => {
    // console.log("editContent called, pContent", pContent);
    await setContentObj(pContent);
    await setContentId(pContent.contentId);
    openEditSlider();
  }

  const deleteContent = () => {
  }

  const handleSelectContent = (pContentId) => {
    // console.log("handleSelectContent called, pContentId", pContentId);
    const updatedLstContent = lstContentId.includes(pContentId)
      ? lstContentId.filter((id) => id !== pContentId)
      : [...lstContentId, pContentId];

    setLstContentId(updatedLstContent);
  }

  const handleChangeContentObj = (pContent) => {
    setContentObj(pContent);
    setContentId(pContent.contentId);
  }

  const openEditSlider = () => {
    setFlgContentSliderVisible(true);
  }

  const closeEditSlider = () => {
    setFlgContentSliderVisible(false);
  }

  const updateKey = () => {
    setKey(prevKey => prevKey + 1);
  }

  return (
    <div >
      <Header />
      <ToastContainer autoClose={3000} hideProgressBar />
      <Loader loader={loader} position="fixed" />
      <div className="col-md-12 col-xs-12 col-centered padding-remove"
        style={{
          cursor: (loader === "none") ? 'pointer' : 'none',
          pointerEvents: (loader === "none") ? 'auto' : 'none',
          opacity: opacity
        }}>
        <div className="col-md-10 col-sm-10 col-xs-10 col-centered padding-remove" style={{ marginTop: "35px" }}>
          <div className="col-md-11 col-sm-11 col-xs-11  padding-remove" >
            <ContentTbl
              key={lstContent}
              lstContent={lstContent}
              lstContentId={lstContentId}
              contentId={contentId}
              handleChangeContentObj={handleChangeContentObj}
              editContent={editContent}
              deleteContent={deleteContent}
              handleSelectContent={handleSelectContent}
              mediaTypes={mediaTypes}
              orientations={orientations}
              />
          </div>
          <div className="col-md-1 col-sm-1 col-xs-1 text-center padding-remove" >
            <span
              id="addContent"
              title="Add Content"
              className="addIcon glyphicon glyphicon-plus-sign"
              onClick={() => addContent()}
              ></span>
          </div>
        </div>
      </div>
      {
        flgContentSliderVisible ?
        <div className="slider1-60">
            <ContentSlider
              contentDtls={contentObj}
              closeSlider={closeEditSlider}
              updateKey={updateKey}
              mediaTypes={mediaTypes}
              orientations={orientations}
              contentBasePath={contentBasePath}
            />
          </div>
          : null
      }
    </div>
  )
}

export default PanelContentCtrl;

